import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { interval, Subscription } from 'rxjs';

@Component({
    selector: 'app-idle-timeout-modal',
    templateUrl: './idle-timeout-modal.component.html',
    styleUrl: './idle-timeout-modal.component.scss'
})
export class IdleTimeoutModalComponent implements OnInit, OnDestroy {
    remainingSeconds: number = 0;
    private sub?: Subscription;

    constructor(
        private dialogRef: MatDialogRef<IdleTimeoutModalComponent>,
        @Inject(MAT_DIALOG_DATA) public data: { remainingMs: number }
    ) {}

    ngOnInit(): void {
        this.remainingSeconds = Math.ceil(this.data.remainingMs / 1000);

        this.sub = interval(1000).subscribe(() => {
            this.remainingSeconds--;

            if (this.remainingSeconds <= 0) {
                this.forceLogout();
            }
        });
    }

    stayLoggedIn(): void {
        this.cleanup();
        this.dialogRef.close({ stayLoggedIn: true });
    }

    logout(): void {
        this.cleanup();
        this.dialogRef.close({ logout: true });
    }

    private forceLogout(): void {
        this.cleanup();
        this.dialogRef.close({ forceLogout: true });
    }

    private cleanup(): void {
        this.sub?.unsubscribe();
    }

    ngOnDestroy(): void {
        this.cleanup();
    }
}
